const EVENT_PASSWORD_LENGTH = 4;

const RULE = {
  maxEventNameLength: 20,
  maxEventPasswordLength: EVENT_PASSWORD_LENGTH,
  minMemberNameLength: 1,
  maxMemberNameLength: 8,
  maxPrice: 10000000,
  minBillNameLength: 1,
  maxBillNameLength: 30,
  minAccountNumberLength: 8,
  maxAccountNumberLength: 30,
};

export default RULE;
